import { ROLES_CONST } from 'configs/localData/permissions';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getCurrentRole } from 'redux/auth/selectors';
import { checkRole } from 'utils/tools';

const useCheckPermissionMetrics = () => {
  const currentRole = useSelector(getCurrentRole);

  const isCanViewMarketingMetrics = useMemo(
    () =>
      checkRole(
        [
          ROLES_CONST.companyAdmin,
          ROLES_CONST.providerAdmin,
          ROLES_CONST.centreAdmin,
        ],
        currentRole,
      ),
    [currentRole],
  );

  return isCanViewMarketingMetrics;
};

export default useCheckPermissionMetrics;
